// extracted by mini-css-extract-plugin
export default {"wrapper":"Magnifier_wrapper__TrGP2","image":"Magnifier_image__EbnO7","lens":"Magnifier_lens__2Z26L"};